import { Config } from './Config'

export function getGithubOauthUrl(config: Config) {
  const redirectUrl = `${config.api.fullUrl}gh/redirect?app=app`

  return `https://github.com/login/oauth/authorize?scope=read:org user:email repo:status read:org repo&client_id=${
    config.github.clientId
  }&redirect_uri=${encodeURIComponent(redirectUrl)}`
}
